/* eslint-disable jsx-a11y/no-onchange */
/* eslint-disable arrow-parens */
import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import {
  Button,
} from 'reactstrap';
import { Helmet } from 'react-helmet';
import { Link, useHistory } from 'react-router-dom';
import TheLayout from '../../layout/TheLayout';
import SuccessModal from '../Util/Modal/SuccessModal';
import FailureModal from '../Util/Modal/FailureModal';
import FirstView from '../../asset/firstview.png';
import ContactIcon from '../../asset/Contact/contact.png';
import DataRow from './DataRow';
import {
  sendMail,
  clearResultFlg,
} from '../../redux/actions/contact';

const keywords = ['TERRA', 'contact', 'お問い合わせ'];

const Contact = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [corporateName, setCorporateName] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [subject, setSubject] = useState('商品について');
  const [content, setContent] = useState('');
  const [emailError, setEmailError] = useState('');
  const [nameError, setNameError] = useState('');
  const [phonenumberError, setPhonenumberError] = useState('');
  const [contentError, setContentError] = useState('');
  const isSuccess = useSelector(state => state.contact.isSuccess, shallowEqual);
  const isFailure = useSelector(state => state.contact.isFailure, shallowEqual);
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  /**
  * 送信ボタン押下時の処理
  */
  const onSubmit = () => {
    let error = false;
    const emailRegexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
    const phonenumberRegexp = /(\d{2,3})-?(\d{3,4})-?(\d{4})/;
    if (!emailRegexp.test(email)) {
      setEmailError('Eメールが不正です');
      error = true;
    }
    if (email === '') {
      setEmailError('Eメールを入力してください');
      error = true;
    }
    if (name === '') {
      setNameError('担当者名を入力してください');
      error = true;
    }
    if (!phonenumberRegexp.test(phonenumber)) {
      setPhonenumberError('TELが不正です');
      error = true;
    }
    if (phonenumber === '') {
      setPhonenumberError('TELを入力してください');
      error = true;
    }
    if (content === '') {
      setContentError('お問い合わせ内容を入力してください');
      error = true;
    }
    if (error === true) {
      return;
    }
    const param = {
      to: `${process.env.REACT_APP_CONTACT_MAIL_ADDRESS}`,
      from: email,
      subject,
      text: 'text',
      html: `<div>
        <p>email: ${email}</p>
        <p>法人名: ${corporateName}</p>
        <p>担当者名: ${name}</p>
        <p>TEL: ${phonenumber}</p>
        <p>お問い合わせ分野: ${subject}</p>
        <p>お問い合わせ内容:</p>
        <span>${content.replace(/\r?\n/g, '<br />')}</span>
      </div>`,
    };
    dispatch(sendMail(param));
  };

  const closeResultModal = () => {
    dispatch(clearResultFlg());
  };

  const gotoHome = () => {
    dispatch(clearResultFlg());
    history.push('/');
  };

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>お問い合わせ｜株式会社TERRA</title>
      </Helmet>
      <div className="contact">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          お問い合わせ
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>お問い合わせ</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <div className="row">
            <div className="col">
              <div className="p-2" style={{ color: 'rgb(44,81,115)' }}>
                <div className="container contact_content">
                  <div className="contact_top_text text-center">
                    <p className="my-3">
                      商品、ご注文、会員登録などについての
                      <br className="d-sm-block d-md-none" />
                      お問合せはこちらから
                    </p>
                    <br />
                    <div
                      className="d-flex justify-content-center align-items-center p-3 m-auto"
                      style={{
                        borderRadius: '30px',
                        background: 'rgb(205,226,233)',
                        fontSize: '3rem',
                        letterSpacing: '0.5rem',
                      }}
                    >
                      <img className="mr-5" src={ContactIcon} style={{ height: '2.5rem' }} alt="お問い合わせ" />
                      <p className="font-weight-bold">0120-406-510</p>
                    </div>
                    <p className="my-5" style={{ lineHeight: '2' }}>
                      メールフォームでのお問い合わせは、
                      <br />
                      <span style={{ color: 'rgb(232,94,89)' }}>必須項目</span>
                      を記入の上お問い合わせください。
                    </p>
                  </div>
                  <div className="row g-0">
                    <div className="col-12 col-lg-4 my-1 my-lg-2">
                      <div className="font-weight-bold fw-bold" style={{ color: 'rgba(57,90,119)' }}>
                        お問い合わせ分野
                        <i style={{ color: 'rgba(232,94,89)' }}>※</i>
                      </div>
                    </div>
                    <div className="col-12 col-lg-4 my-1 my-lg-2">
                      <select
                        className="mb-3"
                        onChange={(e) => {
                          setSubject(e.target.value);
                        }}
                        value={subject}
                        style={{
                          lineHeight: '3',
                          width: '100%',
                          backgroundColor: 'white',
                          padding: '15px',
                          WebkitAppearance: 'auto',
                          color: 'rgb(44,81,115)',
                        }}
                      >
                        <option value="商品について">商品について</option>
                        <option value="ご注文について">ご注文について</option>
                        <option value="会員登録について">会員登録について</option>
                        <option value="その他">その他</option>
                      </select>
                    </div>
                  </div>
                  <DataRow
                    id="corporateName"
                    title="法人名"
                    value={corporateName}
                    onChange={(e) => {
                      setCorporateName(e.target.value);
                    }}
                  />
                  <DataRow
                    id="name"
                    title="担当者名（氏名）"
                    value={name}
                    onChange={(e) => {
                      setNameError('');
                      setName(e.target.value);
                    }}
                    error={nameError}
                    required
                  />
                  <DataRow
                    id="phonenumber"
                    title="TEL"
                    value={phonenumber}
                    onChange={(e) => {
                      setPhonenumberError('');
                      setPhonenumber(e.target.value);
                    }}
                    error={phonenumberError}
                    required
                  />
                  <DataRow
                    id="email"
                    title="メールアドレス"
                    value={email}
                    onChange={(e) => {
                      setEmailError('');
                      setEmail(e.target.value);
                    }}
                    error={emailError}
                    required
                  />
                  <div className="row g-0 py-3">
                    <div className="col-12 col-lg-4 my-1 my-lg-2">
                      <div className="font-weight-bold fw-bold" style={{ color: 'rgba(57,90,119)' }}>
                        お問い合わせ内容
                        <i style={{ color: 'rgba(232,94,89)' }}>※</i>
                      </div>
                    </div>
                    <div className="col-12 col-lg-8 my-1 my-lg-2">
                      <textarea
                        id="content"
                        name="content"
                        rows="10"
                        cols="100"
                        value={content}
                        onChange={(e) => {
                          setContentError('');
                          setContent(e.target.value);
                        }}
                        style={{
                          width: '100%',
                          border: contentError ? '1px solid red' : 'none',
                          backgroundColor: 'white',
                        }}
                      />
                      <span style={{ color: '#ff0000', fontSize: '12px' }}>
                        &nbsp;&nbsp;
                        {contentError}
                      </span>
                    </div>
                  </div>
                  <br />
                  <Button
                    className="btn_submit m-auto p-3"
                    type="submit"
                    onClick={onSubmit}
                    size="lg"
                    block
                    style={{ width: '300px', borderRadius: '30px', background: 'rgb(44,81,115)' }}
                  >
                    <div className="d-flex justify-content-between">
                      <div className="text-center" style={{ width: '90%', paddingLeft: '5%', letterSpacing: '0.5rem' }}>送信</div>
                      <div style={{ paddingRight: '10px' }}>&#10095;</div>
                    </div>
                  </Button>
                  <br />
                  <br />
                </div>
                {/* 成功モーダル */}
                <SuccessModal
                  isOpen={isSuccess}
                  onclickOK={gotoHome}
                  message="お問い合わせが完了しました!<br>お問い合わせありがとうございました。<br>後ほど担当者からご連絡いたします。"
                />
                {/* 失敗モーダル */}
                <FailureModal
                  isOpen={isFailure}
                  onclickOK={closeResultModal}
                  message="お問い合わせに失敗しました。"
                  detail="時間を置いてもう一度お試しください。"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Contact;
